import React from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Offer from '../tabs/offer/Offer';
import IdeaContent from '../tabs/idea/IdeaContent';
import EnhancedAudienceData from '../tabs/audience/EnhancedAudienceData';
import { Reviews } from '../tabs/reviews/Reviews';
import { useTranslation } from 'react-i18next';
import TabList from '@mui/lab/TabList';
import TabContext from '@mui/lab/TabContext';
import { useDispatch, useSelector } from 'react-redux';
import { IAllStates } from '../../../../../../../store/rootReducer';
import TabPanel from '@mui/lab/TabPanel';
import { setActiveTab } from '../../../../../../../store/brand/offerBrandSlice';
import { History } from '../tabs/history/History';
import { OfferComments } from '../../../../../../../shared/components/offer/offer-comments/OfferComments';

function ModalTabs() {
    const { activeTabModal, campaign, canWriteComment, hasUnreadComments, userId, user } = useSelector(
        (state: IAllStates) => state.offerBrand
    );
    const { isClient } = useSelector((state: IAllStates) => state.auth.user);
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const isMobile = window.innerWidth <= 700;
    const isProposed = campaign?.offers?.[0]?.isProposed;
    const hideClientTabs =
        isClient && ['accepted', 'completed'].includes(campaign?.offers?.[0]?.status ?? '');

    const handleTab = (event: React.SyntheticEvent, newValue: string) => {
        dispatch(setActiveTab(newValue));
    };

    return (
        <Box sx={{ width: '100%' }}>
            <TabContext value={activeTabModal}>
                <Box className="mb-md-3 position-sticky">
                    <TabList
                        allowScrollButtonsMobile={isMobile}
                        variant={isMobile ? 'scrollable' : 'fullWidth'}
                        onChange={handleTab}
                        centered
                    >
                        <Tab label={t('brand.campaign.book.offer.modal.offer')} value="0" />
                        <Tab label={t('brand.campaign.book.offer.modal.content')} value="1" />
                        <Tab label={t('brand.campaign.book.offer.modal.audience')} value="2" />
                        {!isProposed && !hideClientTabs && (
                            <Tab label={t('brand.campaign.book.offer.modal.reviews')} value="3" />
                        )}
                        {!isProposed && !hideClientTabs && campaign?.offers && campaign?.offers?.length > 0 && (
                            <Tab
                                label={t('brand.campaign.book.offer.modal.comments')}
                                icon={<> {hasUnreadComments && <span className="notification-comment-badge"></span>}</>}
                                value="4"
                            />
                        )}
                        {!isProposed && !hideClientTabs && campaign?.offerPlaceholder?.flags?.hasHistory && (
                            <Tab label={t('brand.campaign.book.offer.modal.history')} value="5" />
                        )}
                    </TabList>
                </Box>
                <Box className="modal-right-content px-md-3">
                    <TabPanel value="0">
                        <Offer />
                    </TabPanel>
                    <TabPanel value="1">
                        <IdeaContent user={user} campaign={campaign} />
                    </TabPanel>
                    <TabPanel value="2">
                        <EnhancedAudienceData activeTabModal={activeTabModal} userId={userId} user={user} />
                    </TabPanel>
                    {!isProposed && !hideClientTabs && (
                        <TabPanel value="3">
                            <Reviews userId={userId} />
                        </TabPanel>
                    )}
                    {!isProposed && !hideClientTabs && campaign?.offers && campaign?.offers?.length > 0 && (
                        <TabPanel className="p-0 h-100" value="4">
                            <OfferComments canWriteComment={canWriteComment} offerId={campaign?.offers[0]?.id ?? 0} />
                        </TabPanel>
                    )}
                    {!isProposed && !hideClientTabs && campaign?.offerPlaceholder?.flags?.hasHistory && (
                        <TabPanel value="5">
                            <History />
                        </TabPanel>
                    )}
                </Box>
            </TabContext>
        </Box>
    );
}

export default ModalTabs;
